import config from 'config';

export const debug = (...message: any[]) => {
  if (config.DEBUG) console.log(...message);
}

export default debug;
